import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Home from "../Pages/frontend/Frontend";

import AcademyRegister from "../Auth/Academy/AcademyRegister";
import Features from "../Pages/Features";
import Header from "../Pages/frontend/Header";
import Footer from "../Pages/frontend/Footer";

export default function RouteFile() {
  const navigate = useNavigate();

  const loginStatus = useSelector((state) => state.login.user_type);

  return (
    <>
      <div className="wrapper">
        <Header />
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="academy-register" element={<AcademyRegister header={false} />} />
            <Route path="features" element={<Features />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer/>
      </div>
    </>
  );
}
